module.exports = __webpack_public_path__ + "assets/0.1.11/img/404.a57b6f31.png";